import BrowseThumbLayoutContainer from './BrowseThumbLayout.container';
import BrowseThumbLayout from './BrowseThumbLayout';

export default BrowseThumbLayoutContainer(BrowseThumbLayout);
